import styled from 'styled-components';

export const MedicationName = styled.div`
  font-size: 10.5px;
  font-weight: 700;
  color: #111;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const MedicationSubtype = styled.div`
  font-size: 8.5px;
  color: #999;
`;

export const NotesLine = styled.div`
  font-size: 9px;
  color: #777;
  font-style: italic;
  margin-top: 2px;
  overflow-wrap: anywhere;
  word-break: break-word;
`;
